// new_database.tsx
import './new_database.css';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ModeLanding, { type ModeId } from './ModeLanding';
import CrudeMode from './modes/CrudeMode';
import VacMode from './modes/VacMode';
import NglMode from './modes/NglMode';

const NewDatabase = () => {
    const location = useLocation();
    const { rid, monthYearName, applyFilter } = location.state || {};

    const [activeMode, setActiveMode] = useState<ModeId | null>(null);
    const [initialMonth, setInitialMonth] = useState<string>('');

    const handleEnterMode = (mode: ModeId, month: string) => {
        setInitialMonth(month);
        setActiveMode(mode);
    };

    const handleChangeMode = (mode: ModeId) => setActiveMode(mode);
    const handleBackToOverview = () => setActiveMode(null);

    return (
        <div className="ticketData-mainContainer">
            {!activeMode && (
                <ModeLanding onEnterMode={handleEnterMode} />
            )}

            {activeMode === 'crude' && (
                <CrudeMode
                    initialMonth={initialMonth}
                    initialRid={applyFilter ? rid : undefined}
                    initialMonthForRid={applyFilter ? monthYearName : undefined}
                    onChangeMode={handleChangeMode}
                    onBackToOverview={handleBackToOverview}
                />
            )}

            {activeMode === 'vac' && (
                <VacMode
                    initialMonth={initialMonth}
                    onChangeMode={handleChangeMode}
                    onBackToOverview={handleBackToOverview}
                />
            )}

            {activeMode === 'ngl' && (
                <NglMode
                    initialMonth={initialMonth}
                    onChangeMode={handleChangeMode}
                    onBackToOverview={handleBackToOverview}
                />
            )}
        </div>
    );
};

export default NewDatabase;
